import classnames from 'classnames/bind'
import { useState } from 'react'
import { useTranslate } from 'react-polyglot'
import { GlobalTextPreset } from '~/@types/text-preset'
import { GlobalTextStyling } from '~/@types/text-styling'
import { SIZE_GUIDE_TYPES } from '~/lib/constants'

import SizeSwitch from '~/components/Panels/SizeGuidePanel/SizeSwitch'
import TableGuide from '~/components/Panels/SizeGuidePanel/TableGuide'

import { useStyle } from '~/providers/StyleProvider'

import useSizeGuideTable from '~/hooks/useSizeGuideTable'

import { SIZE_GUIDE } from '~/data/dictionary'

import css from './styles.module.scss'

const cx = classnames.bind(css)

interface SizeGuidePanelProps {
  className?: string
  data?: string[]
}

function SizeGuidePanel({ className, data }: SizeGuidePanelProps) {
  const t = useTranslate()
  const [unit, setUnit] = useState<'CM' | 'INCH'>('CM')

  const isRing = data?.includes(SIZE_GUIDE_TYPES.RING) ?? false
  const isShoes = data?.includes(SIZE_GUIDE_TYPES.SHOES) ?? false

  const titleStyles = useStyle({
    textPreset: GlobalTextPreset.Label12Haffer,
    textStyling: GlobalTextStyling.UpperCase,
  })

  const descriptionStyles = useStyle({
    textPreset: GlobalTextPreset.Text12Haffer,
  })

  const noticeStyles = useStyle({
    textPreset: GlobalTextPreset.Text11Haffer,
    textStyling: GlobalTextStyling.UpperCase,
  })

  const tables = useSizeGuideTable(data, isRing, isShoes)

  const hasSizeSwitch = !isRing && !isShoes
  const description = isShoes
    ? t(SIZE_GUIDE.DESCRIPTION_SHOES)
    : t(SIZE_GUIDE.DESCRIPTION)

  return (
    <div className={cx(css.SizeGuidePanel, className)}>
      <div className={cx(css.top)}>
        <h2 className={titleStyles}>{t(SIZE_GUIDE.TITLE)}</h2>
      </div>
      <div className={css.body}>
        {description && (
          <p className={cx(css.description, descriptionStyles)}>
            {description}
          </p>
        )}
        {hasSizeSwitch && <SizeSwitch activeUnit={unit} onChange={setUnit} />}
        <div className={cx(css.tableGuideWrapper)}>
          <TableGuide activeUnit={unit} data={tables} />
        </div>
        <p className={cx(css.notice, noticeStyles)}>{t(SIZE_GUIDE.NOTICE)}</p>
      </div>
    </div>
  )
}

export default SizeGuidePanel
